<template lang="pug">
.form-page
    .header
        IQToolMiddlePaneHeader(:header="$t(`${baseTranslationPath}.manage`)"
           @goToListPage="navigateAway()")
        .button-container
              aiq-button(size="small" class="btn" @click="saveForm(true)") {{ $t(`${baseTranslationPath}.save_as_draft`) }}
              aiq-button(type="primary" size="small" class="btn" @click="saveForm(false)") {{ $t(`${baseTranslationPath}.publish`) }}
    EditArea.edit-area
        template(#content)
            Fields(:formDetails="formDetails")
</template>
<script>
import IQToolMiddlePaneHeader from '@/pages/IQTools/Partials/IQToolMiddlePaneHeader/IQToolMiddlePaneHeader.vue';
import Upload from './Upload.vue';
import EditArea from '@/components/EditArea.vue';
import Fields from './Fields.vue';
import get from 'lodash/get';

export default {
  name: 'FormPage',
  components: {
    IQToolMiddlePaneHeader,
    Upload,
    EditArea,
    Fields,
  },
  data() {
    return {
      baseTranslationPath: 'iq_tools_tab.forms_tab.manage',
      formDetails: null,
    };
  },
  async mounted() {
    await this.init();
  },
  methods: {
    async init() {
      const id = get(this, '$route.params.id');
      const formDetails = await this.$store.dispatch('agentForms/getForm', { id });
      this.formDetails = formDetails.data;
    },
    navigateAway() {
      // editor is contained by a route
      const id = get(this, '$route.params.id');
      if (id && this.$route.matched.length > 1) {
        // get the parent path
        const currentPath = this.$route.path;
        const parentPath = currentPath.substring(
          0,
          currentPath.lastIndexOf('/'),
        );
        // get parant name if exist
        const name = get(this.$route, 'meta.parentName');
        // move to the parent
        this.$router.push(name ? { name } : parentPath);
      }
    },
    async saveForm(value = false) {
      const id = get(this, '$route.params.id');
      const payload = {
        id,
        body: {
          title: this.formDetails.title,
          draft: value,
        },
      };
      try {
        await this.$store.dispatch('agentForms/updateForm', payload);
        this.$aiq.notify.success('Form saved successfully');
        this.navigateAway();
      } catch (_) {
        this.$aiq.notify.error('Error while saving form');
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.button-container {
  display: flex;
  gap: 5px;
  justify-content: flex-end;
}

.form-page {
  padding: 30px;
}

.edit-area {
  margin-top:30px;
}

.btn {
  height: 40px;
  width: 90px;
}
</style>